'use client';

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';

const LoadingComponent = () => {
  const [msg, setMsg] = useState(false);
  const router = useRouter();

  useEffect(() => {
    const timer = setTimeout(() => {
      setMsg(true);
    }, 3000);

    const redirectTimer = setTimeout(() => {}, 10000);

    return () => {
      clearTimeout(timer);
      clearTimeout(redirectTimer);
    };
  }, [router]);

  return (
    <div className="container flex h-full flex-col items-center justify-center py-20 text-center">
      <div className="loader-container">
        <span className="spinner"></span>
        <span className="background"></span>
        <img className="logo" src="/favicon.png" alt="icon" />
      </div>
      <div className={`mt-16 text-2xl font-medium leading-loose transition-all duration-300 ${msg ? 'opacity-100' : 'opacity-0'}`}>
        It appears like the page is taking unusually long time to load.
        <br />
        You can try refreshing to load faster.
      </div>
      <style jsx>{`
        .loader-container {
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          width: 100px;
          height: 100px;
          border-radius: 50%;
        }

        .background,
        .spinner {
          position: absolute;
          display: inline-block;
          height: 100%;
          width: 100%;
        }

        .background {
          border-radius: 50%;
          box-shadow:
            0 4px 4px -1px rgb(187 194 44 / 30%),
            0 4px 6px 1px rgb(151 172 56 / 50%),
            0 18px 32px -2px rgba(255, 255, 255, 0.1) inset;
        }

        .logo {
          width: 50%;
          aspect-ratio: 1/1;
          filter: drop-shadow(2px 2px 2px #999);
          z-index: 2;
        }

        .spinner {
          border-radius: 50%;
          border-top: 1px solid #e91c23;
          box-shadow: 0 -3px 5px rgba(233, 28, 35, 0.5);
          animation: spin 1500ms linear infinite;
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
};

export default LoadingComponent;
